import { Backdrop, CircularProgress } from '@mui/material';

const Loader = ({ open, setOpen }) => {

  return (<Backdrop sx={{ color: '#ef233c', zIndex: 1400 }} open={open} onClick={(e) => setOpen(false)}>
    <CircularProgress color="inherit" size={50} />
  </Backdrop>);
}

export default Loader;